// COMPONETS
const BloodBank = () => (
  <div className="flex flex-col p-3">
    <h1 className="font-bold">ব্লাড ব্যাংক</h1>
    <div className="flex flex-col shadow mt-3">
      <h3 className="text-blue-500">নওগাঁ ব্লাড ব্যাংক</h3>
      <p>ঠিকানা: নওগাঁ সদর হাসপাতালের সামনে, নওগাঁ সদর, নওগাঁ</p>
      <span>
        যোগাযোগঃ
        <p>01717-765263</p>
        <p>01785-046786</p>
      </span>
    </div>
  </div>
);

// EXPORT
export default BloodBank;
